import { Pipe, PipeTransform } from "@angular/core";
import { AbstractControl } from "@angular/forms";

@Pipe({
    name: "rawValue",
    standalone: false
})
export class RawValuePipe implements PipeTransform {
  transform(control: AbstractControl): any {
    return control.getRawValue();
  }
}
